import React, { useEffect, useContext, useState } from 'react'
import MainSlider from './MainSlider';
//import BookCategories from './BookCategories';
import AboutUs from './AboutUs';
//import CustomerSection from './CustomerSection';
//import BlogSection from './BlogSection';
import { ProductContext } from '../ProductProvider';
import ContactUs from './ContactUs';
import BookCategoryCaroselHome from './BookCategoryCaroselHome';
import {Helmet} from 'react-helmet-async';
import MainSliderCarosel from './MainSliderCarosel';

export default function HomePage() {
  const { loggedUser, validateLogin } = useContext(ProductContext);
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(()=>{
    if(!loggedUser.isAuthenticated){
      validateLogin();
    }else{
      window.scrollTo(0, 0);
    }
  },[loggedUser])

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Modern background for the whole page
  useEffect(() => {
    document.body.style.background = 'linear-gradient(135deg, #f8fafc 0%, #e0f7fa 100%)';
    document.body.style.backgroundAttachment = 'fixed';
    document.body.style.minHeight = '100vh';
    return () => {
      document.body.style.background = '';
      document.body.style.backgroundAttachment = '';
      document.body.style.minHeight = '';
    };
  }, []);

  return (
    <div style={{ minHeight: '100vh', fontFamily: 'Inter, Segoe UI, Arial, sans-serif' }}>
      <Helmet>
        <title>Home - Inigo Library - Arul Kadal - Chennai</title>
        <meta name="description" content="Inigo Library - Arul Kadal - Chennai" />
        <meta name="keywords" content="Inigo Library - Arul Kadal - Chennai" />
      </Helmet>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 12px' }}>
        <section style={{ marginBottom: 32 }}>
          <MainSliderCarosel />
        </section>
        <section style={{ marginBottom: 32 }}>
          <BookCategoryCaroselHome />
        </section>
        {/*<BookCategories />*/}
        <section style={{ marginBottom: 32 }}>
          <AboutUs />
        </section>
        {/*<CustomerSection />
        <BlogSection />*/}
        <section style={{ marginBottom: 32 }}>
          <ContactUs />
        </section>
      </div>

      {/* Scroll To Top Icon */}
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          style={{
            position: 'fixed',
            bottom: '32px',
            right: '32px',
            zIndex: 9999,
            background: 'linear-gradient(135deg, #063547 60%, #0bb6d7 100%)',
            color: '#fff',
            border: 'none',
            borderRadius: '50%',
            width: '52px',
            height: '52px',
            boxShadow: '0 2px 12px #0bb6d733',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '24px',
            transition: 'background 0.3s',
          }}
          aria-label="Scroll to top"
          title="Scroll to top"
        >
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="12" fill="#0bb6d7"/>
            <path d="M12 16V8M12 8L8 12M12 8l4 4" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      )}
    </div>
  )
}
